import React from 'react';
import { Link } from 'react-router-dom';

interface CategorySectionProps {
    sectionId: string;
    internalSectionId: string;
    categoryName: string;
    className?: string;
    children: React.ReactNode;
    seeAllLink?: string;
    subTitle?: string;
}

function CategorySection({
    sectionId,
    internalSectionId,
    categoryName,
    className = '',
    children,
    seeAllLink = '/categories',
    subTitle = ''
}: CategorySectionProps) {
    return (
        <section id={sectionId} className={`${internalSectionId.toLowerCase()}-category section ${className}`}>
            {/* Section Title */}
            <div className="container section-title">
                <div className="section-title-container d-flex align-items-center justify-content-between">
                    <h2>{categoryName}</h2>
                    {subTitle && <p><Link to={seeAllLink}>{subTitle}</Link></p>}
                    {!subTitle &&<p><Link to={seeAllLink}>See All {categoryName}</Link></p>}
                </div>
            </div>

            <div className="container">
                {children}
            </div>
        </section>
    );
}

export default CategorySection;

